import { Theme, lighten } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

interface TaskStatusStyleProps {
  colour?: string
}

const useStyles = makeStyles<Theme, TaskStatusStyleProps>(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: ({ colour }) =>
      colour && colour.toLocaleLowerCase() !== '#ffffff'
        ? lighten(`#${colour}`, 0.8)
        : 'lightgrey',
    borderRadius: 12,
    padding: '3px 6px'
  },

  truncate: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  }
}))

export default useStyles
